import { DEFAULT_DISPLAY_FORMAT, DEFAULT_TIME_ZONE_POLICY } from './policy.js';
import { resolveDisplayTimeZone } from './resolve-time-zone.js';
import { getZoneOffsetMs } from './zone-offset.js';
import { toInstantMs } from './to-instant.js';
const pad = (value, width) => String(value).padStart(width, '0');
function applyFormat(format, f) {
    return format.replace(/YYYY|MM|DD|HH|mm|ss|SSS/g, (token) => {
        switch (token) {
            case 'YYYY':
                return pad(f['year'] ?? 0, 4);
            case 'MM':
                return pad(f['month'] ?? 1, 2);
            case 'DD':
                return pad(f['day'] ?? 1, 2);
            case 'HH':
                return pad(f['hour'] ?? 0, 2);
            case 'mm':
                return pad(f['minute'] ?? 0, 2);
            case 'ss':
                return pad(f['second'] ?? 0, 2);
            case 'SSS':
                return pad(f['millisecond'] ?? 0, 3);
            default:
                return token;
        }
    });
}
export function formatInstant(value, options = {}) {
    const fallback = options.fallback ?? '-';
    if (value === null || value === undefined)
        return fallback;
    const instantMs = toInstantMs(value, options.legacyOffsetlessAsUtc ?? false);
    if (instantMs === undefined)
        return fallback;
    const policy = options.policy ?? DEFAULT_TIME_ZONE_POLICY;
    const timeZone = resolveDisplayTimeZone(policy, options.deviceTimeZone);
    const zoned = new Date(instantMs + getZoneOffsetMs(timeZone, instantMs));
    return applyFormat(options.format ?? DEFAULT_DISPLAY_FORMAT, {
        year: zoned.getUTCFullYear(),
        month: zoned.getUTCMonth() + 1,
        day: zoned.getUTCDate(),
        hour: zoned.getUTCHours(),
        minute: zoned.getUTCMinutes(),
        second: zoned.getUTCSeconds(),
        millisecond: zoned.getUTCMilliseconds(),
    });
}
//# sourceMappingURL=format-instant.js.map